<template>
  <component :is="this.$route.meta.layout ?? LayoutDefault">
    <router-view />
  </component>
</template>

<script>
import { defineComponent } from "vue";

import LayoutDefault from "@/layouts/LayoutDefault.vue";
import ".//assets/global.css";
export default defineComponent({
  setup() {
    return {
      LayoutDefault,
    };
  },

  data() {
    return {
      hide: false,
      pages: [{ text: "Login", to: "/login", class: "bi bi-person" }],
    };
  },
});
</script>
